import { render, staticRenderFns } from "./redpacketConfig.vue?vue&type=template&id=6bc9cf3d&scoped=true"
import script from "./redpacketConfig.vue?vue&type=script&lang=js"
export * from "./redpacketConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc9cf3d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Developer\\Projects\\new-lottery-assistant-qd\\mer_plat_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bc9cf3d')) {
      api.createRecord('6bc9cf3d', component.options)
    } else {
      api.reload('6bc9cf3d', component.options)
    }
    module.hot.accept("./redpacketConfig.vue?vue&type=template&id=6bc9cf3d&scoped=true", function () {
      api.rerender('6bc9cf3d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/lottery-assistant/redpacket/redpacketConfig.vue"
export default component.exports